<script>
  import Button from '@components/button.svelte'
  import { format, isToday } from "date-fns";
  import { fr } from "date-fns/locale";
  import { cn } from '@lib/utils'

  let { date } = $props();

  // Get the calendar id from url param "clinic" then formulate path as "/calendriers/[clinicId]?days=1&rm=0&date=2026-04-22
  let clinicId = new URLSearchParams(window.location.search).get("clinic") || 1
  let formattedDate = date.toISOString().split("T")[0]

  let path = $derived(`/calendriers/${clinicId}?days=1&rm=0&date=${formattedDate}`)

  let hint = $derived(`Vers le calendrier`)

</script>

<Button variant="naked" {path} {hint} tooltipDelay={800} class={cn("presence-cell flex gap-2 w-20 shrink-0 hover:bg-blue-50/80", isToday(date) ? "bg-yellow-50" : "")}>
  <span class="uppercase text-xxs">{format(date, "EEE", { locale: fr })}</span>
  <span class="font-semibold text-lg">{date.getDate()}</span>
</Button>
